import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React, { forwardRef } from 'react';
import { func, node, string } from 'prop-types';
import { Container } from './item.styles';
import ItemHeader from './item-header';
import ItemDescription from './item-description';
import ItemContent from './item-content';
const Item = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    as,
    onClick
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["as", "onClick"]);

  const children = React.Children.toArray(props == null ? void 0 : props.children);
  const useOnlyContainer = children == null ? void 0 : children.find(({
    type: {
      displayName
    } = {}
  }) => displayName == null ? void 0 : displayName.includes('ItemHeader'));
  return useOnlyContainer ? /*#__PURE__*/React.createElement(Container, _extends({
    ref: ref,
    forwardedAs: as,
    onClick: onClick,
    "data-testid": "item-container"
  }, props), children) : /*#__PURE__*/React.createElement(ItemHeader, _extends({
    ref: ref,
    as: as,
    onClick: onClick
  }, props));
});
process.env.NODE_ENV !== "production" ? Item.propTypes = Object.assign({
  /**
   * The content of the component,
   */
  children: node,

  /**
   * Called when click over Item.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   */
  onClick: func,

  /**
   * Element before after the children
   */
  as: string
}, ItemHeader.propTypes) : void 0;
Item.defaultProps = {
  title: '',
  children: null
};
Item.Content = ItemContent;
Item.Description = ItemDescription;

Item.Header = props => /*#__PURE__*/React.createElement(ItemHeader, _extends({
  px: 0,
  py: 0
}, props));

Item.Header.displayName = 'ItemHeader';
Item.displayName = 'Item';
export default Item;